module.exports = __webpack_public_path__ + "fonts/Lexend-Black.644be69.woff2";